import COLORS from "common/Colors";
import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledDropzone = styled.div`
  text-align: center;
  padding: 20px;
  width: 100%;
  margin: auto;
  height: 300px;
  background: #e3e3e3;
  border-radius: 5px;
  .anticon {
    padding-top: 5rem;
  }
  .message {
    font-size: 1rem;
    padding-top: 1rem;
    color: ${COLORS.GREY};
  }
  .upload-icon {
    font-size: 3rem;
    color: ${COLORS.GREY};
  }
`;

const Dropzone = ({ onDrop, accept, fileName, access }) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    disabled: !access,
  });

  return (
    <>
      <StyledDropzone className="dropzone-div" {...getRootProps()}>
        {access ? (
          <input className="dropzone-input" {...getInputProps()} />
        ) : null}
        <div className="text-center">
          {isDragActive ? (
            <p className="dropzone-content">
              {t("Release to drop the files here")}
            </p>
          ) : (
            <p className="dropzone-content">
              <UploadOutlined className="upload-icon" />
              <div className="message">
                {navigator.userAgent !== "application"
                  ? access
                    ? t("Drag and drop documents here")
                    : t("Upload Permission not allowed")
                  : t("Upload documents")}
              </div>
              <div>{fileName}</div>
            </p>
          )}
        </div>
      </StyledDropzone>
    </>
  );
};

export default Dropzone;
